import {
  Box, Grid, Skeleton, useTheme,
} from '@mui/material';

interface SkeletonProps {
  numberOfSkeletons: number;
}

export function PartnerCardSkeleton({ numberOfSkeletons }: SkeletonProps) {
  const theme = useTheme();
  const skeletons = Array.from({ length: numberOfSkeletons });

  const SkeletonCard = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
        borderRadius: theme.spacing(1.5),
        backgroundColor: theme.palette.common.white,
        border: `${theme.spacing(0.125)} solid ${theme.palette.grey[200]}`,
        boxShadow: '0 1.25px 2.5px 0 rgba(10, 13, 18, 0.05)',
      }}
    >
      {/* Header section with logo, name, badges and optional "New" badge */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          mb: theme.spacing(1.5),
        }}
      >
        {/* Left side: Logo + Name + Badges */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            flex: 1,
          }}
        >
          {/* Logo */}
          <Box
            sx={{
              paddingRight: theme.spacing(1.5),
            }}
          >
            <Skeleton
              variant="rectangular"
              animation="wave"
              sx={{
                width: theme.spacing(8),
                height: theme.spacing(8),
                borderRadius: theme.spacing(1),
              }}
            />
          </Box>
          {/* Name and badges column */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: theme.spacing(0.625),
              flex: 1,
            }}
          >
            {/* Partner name */}
            <Skeleton
              animation="wave"
              width={120}
              height={20}
            />
            {/* Badge pills */}
            <Box sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: theme.spacing(1),
            }}>
              <Skeleton
                variant="rectangular"
                animation="wave"
                width={80}
                height={20}
                sx={{ borderRadius: theme.spacing(12.5) }}
              />
              <Skeleton
                variant="rectangular"
                animation="wave"
                width={100}
                height={20}
                sx={{ borderRadius: theme.spacing(12.5) }}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Description section */}
      <Box
        sx={{
          width: '100%',
        }}
      >
        <Skeleton animation="wave" height={16} width="100%" sx={{ mb: 0.5 }} />
        <Skeleton animation="wave" height={16} width="90%" sx={{ mb: 0.5 }} />
        <Skeleton animation="wave" height={16} width="75%" />
      </Box>
    </Box>
  );

  return (
    <Grid container spacing={2.5}>
      {skeletons.map((_, index) => (
        <Grid key={index} item xs={12} sm={12} md={6} lg={4}>
          <SkeletonCard />
        </Grid>
      ))}
    </Grid>
  );
}
